import { motion } from "framer-motion";
import ollieFloating from "@/assets/img/ollie-floating.svg";
import { OcdRibbon } from "./OcdRibbon";

export const OllieFloating = () => {
    return (
        <motion.div className="relative flex flex-col items-center justify-center" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
            <motion.div
                animate={{
                    y: [0, -5, 0]
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
                className="relative">
                <motion.img
                    src={ollieFloating}
                    alt="ollie"
                    className="w-32 h-32 z-10"

                />
                <OcdRibbon className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-x-[10px] -translate-y-[25px]" />
            </motion.div>
            {/* Shadow ellipse */}
            <motion.div
                className="absolute left-1/2 -translate-x-1/2 top-[100px] w-10 h-2 bg-black/25 rounded-full blur-sm"
                animate={{
                    scaleX: [1, 1.1, 1],
                    scaleY: [1, 1.05, 1],
                    opacity: [0.8, 0.6, 0.8],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            />
        </motion.div>
    );
};
